import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { I18nextProvider } from "react-i18next";
import i18next from "i18next";
import global_es from "./translations/es/global.json";
import global_en from "./translations/en/global.json";
import { AuthProvider } from "react-oidc-context";
import { WebStorageStateStore } from "oidc-client-ts";

i18next.init({
  interpolation: {
    escapeValue: false,
  },
  lng: "es",
  resources: {
    es: {
      global: global_es,
    },
    en: {
      global: global_en,
    },
  },
});

const oidcConfig = {
  authority: "https://account.idtolu.net/realms/IDT-IDT-DTC-RID-001",
  client_id: "IDT-IDT-DTC-IOT-005",

  redirect_uri: "https://ilesa.idtolu.net",
  post_logout_redirect_uri: "https://ilesa.idtolu.net",

  response_type: "code",
  response_mode: "query",
  scope: "openid profile email",

  automaticSilentRenew: false,
  loadUserInfo: true,
  code_challenge_method: 'S256',

  // monitorSession: false, // Desactiva si hay problemas de CORS

  // Storage
  userStore: new WebStorageStateStore({ store: window.localStorage }),

  // Metadatos explícitos (CRÍTICO)
  metadata: {
    issuer: "https://account.idtolu.net/realms/IDT-IDT-DTC-RID-001",
    authorization_endpoint:
      "https://account.idtolu.net/realms/IDT-IDT-DTC-RID-001/protocol/openid-connect/auth",
    token_endpoint:
      "https://account.idtolu.net/realms/IDT-IDT-DTC-RID-001/protocol/openid-connect/token",
    userinfo_endpoint:
      "https://account.idtolu.net/realms/IDT-IDT-DTC-RID-001/protocol/openid-connect/userinfo",
    end_session_endpoint:
      "https://account.idtolu.net/realms/IDT-IDT-DTC-RID-001/protocol/openid-connect/logout",

    // FORZAR PKCE en metadata
    // code_challenge_methods_supported: ["S256"]
  },

  // Para debug en producción
  // extraHeaders: {
  //   'X-Forwarded-Proto': 'https'
  // },
  // Manejo de errores
  onSigninCallback: (user) => {
    window.history.replaceState({}, document.title, window.location.pathname);
  },
};
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <I18nextProvider i18n={i18next}>
        <AuthProvider {...oidcConfig}>
          <App />
        </AuthProvider>
      </I18nextProvider>
    </BrowserRouter>
  </React.StrictMode>,
);

reportWebVitals();
